var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"header":(_vm.productid + " - " + _vm.itemdescription + " |  " + _vm.person)}},[_c('b-row',{staticClass:"no-mar"},[_c('b-col',{attrs:{"md":"6"}},[_c('form-element',{attrs:{"form-element":{
          type: 'select',
          name: 'productLeft',
          options: _vm.options,
          placeholder: _vm.$t('productLeft'),
          label: _vm.$t('productLeft'),
          required: true,
          selectLabel: 'key',
          size: 12,
        }},model:{value:(_vm.product.lfc),callback:function ($$v) {_vm.$set(_vm.product, "lfc", $$v)},expression:"product.lfc"}})],1),_c('b-col',{attrs:{"md":"6"}},[_c('form-element',{attrs:{"form-element":{
          type: 'select',
          name: 'productRight',
          options: _vm.options,
          placeholder: _vm.$t('productRight'),
          label: _vm.$t('productRight'),
          required: true,
          selectLabel: 'key',
          size: 12,
        }},model:{value:(_vm.product.rfc),callback:function ($$v) {_vm.$set(_vm.product, "rfc", $$v)},expression:"product.rfc"}})],1),_c('b-col',{attrs:{"md":"12"}},[(_vm.allowRepair && _vm.commentFieldRequired)?_c('b-form-checkbox',{attrs:{"name":"repair","value":true,"unchecked-value":false},model:{value:(_vm.product.repair),callback:function ($$v) {_vm.$set(_vm.product, "repair", $$v)},expression:"product.repair"}},[_vm._v(" "+_vm._s(_vm.$t("thisProductWillBeSendBackForRepair"))+" ")]):_vm._e(),(_vm.product.lfc || _vm.product.rfc)?_c('form-element',{attrs:{"form-element":{
          type: 'textarea',
          name: 'comment',
          options: _vm.options,
          placeholder: _vm.$t('comment'),
          label: _vm.$t('comment'),
          required: _vm.commentFieldRequired,
          size: 12,
          maxLength: 178 // Max 200 minus the default text in case of repair. See the RepairProduct method in FunctionControlHandler.cs (App_Code).
        }},model:{value:(_vm.product.comment),callback:function ($$v) {_vm.$set(_vm.product, "comment", $$v)},expression:"product.comment"}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }